module.exports = __webpack_public_path__ + "img/menu burger.77fa3bc5.svg";